import { Link, useNavigate, useParams } from "react-router-dom";
import AdminNavBar from "./AdminNavBar";
import Loading from "../../components/LoadingComponent";
import ErrorComponent from "../../components/ErrorComponent";
import ScrollTopButton from "../../components/ScrollTopButton";
import adminUseFetchBookChapters from "../../custom_hook/adminUseFetchBookChapters";

const AdminChapterList = () => {
  const { bookId } = useParams();
  const { chapters, book, loading, error } = adminUseFetchBookChapters(
    bookId || ""
  );
  const navigate = useNavigate();

  const handleBackToSiteMaterial = () => {
    navigate("/admin/dashboard/", { state: { from: "blogposts" } });
  };

  const handleEditButton = (bookId: string, chapterId: string) => {
    navigate(
      `/admin/site-materials/books/${bookId}/chapters/edit/${chapterId}`
    );
  };
  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorComponent message={error.message} />;
  }
  return (
    <>
      <nav className="navbar navbar-dark bg-dark">
        <AdminNavBar />
      </nav>
      <nav id="bc-nav" aria-label="breadcrumb">
        <ol id="bc-ol" className="breadcrumb">
          <li id="bc-books" className="breadcrumb-item">
            <button
              className="inactive-anchor-link"
              onClick={handleBackToSiteMaterial}
            >
              Site Materials
            </button>{" "}
            <span className="greater-than">&#x02AA2;</span>
          </li>
          <Link
            to={`/admin/site-materials/books`}
            className="breadcrumb-item inactive-anchor-link"
          >
            Books <span className="greater-than">&#x02AA2;</span>
          </Link>

          <li id="bc-active" className="breadcrumb-item active">
            {book?.title}
          </li>
        </ol>
      </nav>
      <div id="create-chapter-btn-container">
        <Link
          id="create-chapter-btn"
          to={`/admin/site-materials/books/${bookId}/chapters/create`}
          className="btn error-page-btn"
        >
          &#43; Add Chapter
        </Link>
      </div>
      <ul className="list-group bg-dark">
        {chapters.map((chapter) => (
          <li
            key={chapter.id}
            id="post-list-row"
            className="d-flex align-items-center"
          >
            <Link
              id="post-list-link"
              className="anchor-link p-2 flex-grow-1 d-flex"
              to={`/admin/site-materials/books/${book?.id}/chapters/${chapter.id}/solutions`}
            >
              <span className="p-2 flex-fill">{chapter.title}</span>
              <span id="book-edition-cell" className="p-2 flex-fill"></span>

              {chapter.completion_status === "Pending" ||
              chapter.completion_status === "Under Review" ? (
                <span className="p-2 flex-fill">
                  {" "}
                  &#9203; {chapter.completion_status}
                </span>
              ) : (
                <span className="p-2 flex-fill">
                  &#9989; {chapter.completion_status}
                </span>
              )}
            </Link>
            <button
              id="edit-post-btn"
              className="btn error-page-btn p-2"
              onClick={() => {
                handleEditButton(
                  book?.id.toString() || "",
                  chapter.id.toString()
                );
              }}
            >
              Edit
            </button>
          </li>
        ))}
      </ul>
      <ScrollTopButton />
    </>
  );
};

export default AdminChapterList;
